import UserFriendlyMessageError, {
  Options as ParentOptions,
} from "./UserFriendlyMessageError";

export type Options = ParentOptions & {
  userFriendlyMessage?: string;
};

export default class AuthorizationError extends UserFriendlyMessageError {
  constructor({
    userFriendlyMessage = "Authorization error.",
    ...otherOptions
  }: Options = {}) {
    super({ ...otherOptions, userFriendlyMessage });
    this.name = this.constructor.name;
  }
}
